import React from "react";
import { Navigate } from "react-router-dom";
import SuperAdminStorageService from "../services/SuperAdminStorageService";

export default function SuperAdminProtectedRoute({ children }) {
  if (!SuperAdminStorageService.isAuthenticated()) {
    return <Navigate to="/super-admin/login" replace />;
  }
  return children;
}

/** Block Super Admin from entering normal user dashboard routes. */
export function UserOnlyProtectedRoute({ children }) {
  if (SuperAdminStorageService.isAuthenticated()) {
    return <Navigate to="/super-admin/dashboard" replace />;
  }
  return children;
}
